import { FREE_LIMITS_WITH_CONTENT } from '../constants/FreeLimits';
export const filterLimits = usageLimitsResponse => {
  return usageLimitsResponse.filter(limit => {
    var _limit$limit;
    return limit.usage != null && ((_limit$limit = limit.limit) !== null && _limit$limit !== void 0 ? _limit$limit : 0) > 0 && FREE_LIMITS_WITH_CONTENT.includes(limit.limitName);
  });
};
export const sortLimitsByHigherUsage = usageLimitsResponse => {
  return usageLimitsResponse.sort((a, b) => {
    const limitAUsageRatio = a.limit ? a.usage / a.limit : 0;
    const limitBUsageRatio = b.limit ? b.usage / b.limit : 0;

    //rule exception: if the limit of a limit is 1
    if (a.limit === 1 && b.limit !== 1) {
      //if limit B has any usage, sort it before limit A
      if (limitBUsageRatio) return 1;

      //if limit A has any usage, sort it before limit B
      return limitAUsageRatio ? -1 : 1;
    } else if (a.limit !== 1 && b.limit === 1) {
      //same idea, but limits are inverted so so are the returns
      if (limitAUsageRatio) return -1;
      return limitBUsageRatio ? 1 : -1;
    }

    //sort in descending order of usage ratio
    return limitBUsageRatio - limitAUsageRatio;
  });
};